import './util/setupConsole';
import React from 'react';
import ReactDOM from "react-dom/client";
import { StyleSheetManager } from "styled-components";
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux";
import ErrorBoundary from "./ErrorBoundary";
import { ThemeProvider } from "./context/ThemeContext";
import Modal from "react-modal";
import "./index.css";

Modal.setAppElement("#root");

const root = ReactDOM.createRoot(document.getElementById('root'));

const blockedStyledProps = new Set([
  "colors",
  "backgroundImage",
  "loginBackground",
  "isLandingPage",
  "zoomLevel",
]);

const filterStyledProps = (prop, defaultValidatorFn) => {
  const isValid = typeof defaultValidatorFn === "function" ? defaultValidatorFn(prop) : true;
  return isValid && !blockedStyledProps.has(prop);
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <ThemeProvider>
          <StyleSheetManager shouldForwardProp={filterStyledProps}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </StyleSheetManager>
        </ThemeProvider>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);
